(function ($) {
	function prepare_logo_upload() {
		const $form = $('#upload-logo');
		if ($form.length <= 0) {
			return;
		}

		const businessId = $form
			.children('input[type=hidden][name=business_id]')
			.val();
		const $logoInput = $form.children('input[type=file]');
		const $submit = $form.children('input[type=submit]');
		const $spinner = $form.children('.spinner');

		$form.on('submit', (e) => {
			e.preventDefault();

			$submit.hide();
			$spinner.show();

			const fd = new FormData();
			const files = $logoInput[0].files;

			fd.append('business_id', businessId);

			for (let item of files) {
				// Ignore non-image files
				if (item.type.indexOf('image') < 0) {
					continue;
				}

				fd.append('filename', item.name);
				fd.append('blob', item);
			}

			$.ajax({
				type: 'POST',
				enctype: 'multipart/form-data',
				url: `/wp-json/feat/v1/logo/upload?_wpnonce=${wp_rest_nonce}`,
				data: fd,
				processData: false,
				contentType: false,
				success: function (data) {
					if (data.status != 'ok') {
						alert(data.msg);
						return;
					}

					$form.children('p.status-msg').show();
				},
				error: function (e) {
					console.error(e);
					alert(e);
					$submit.show();
				},
				complete: function () {
					$spinner.hide();
				},
			});
		});
	}

	window.addEventListener('load', function (event) {
		prepare_logo_upload();
	});
})(jQuery);
